{
  "accessed": "2026-09-12",
  "publicationDate": null,
  "observationEnd": "2025-03",
  "groups": [
    {
      "code": "31",
      "name": "Manufacturing",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_31_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 14816,
          "survival": 89.8,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 10063,
          "survival": 61,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 7476,
          "survival": 45.3,
          "line": 561
        }
      ]
    },
    {
      "code": "44",
      "name": "Retail trade",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_44_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 50697,
          "survival": 90.2,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 34691,
          "survival": 61.7,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 24867,
          "survival": 44.2,
          "line": 561
        }
      ]
    },
    {
      "code": "51",
      "name": "Information",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_51_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 10864,
          "survival": 80.8,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 6285,
          "survival": 46.8,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 4033,
          "survival": 30,
          "line": 561
        }
      ]
    },
    {
      "code": "52",
      "name": "Finance and insurance",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_52_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 24417,
          "survival": 85.5,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 16063,
          "survival": 56.2,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 10955,
          "survival": 38.4,
          "line": 561
        }
      ]
    },
    {
      "code": "54",
      "name": "Professional, scientific, and technical services",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_54_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 78196,
          "survival": 81.6,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 48226,
          "survival": 50.3,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 32925,
          "survival": 34.3,
          "line": 561
        }
      ]
    },
    {
      "code": "62",
      "name": "Health care and social assistance",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_62_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 95409,
          "survival": 84.6,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 64553,
          "survival": 57.3,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 41030,
          "survival": 36.4,
          "line": 561
        }
      ]
    },
    {
      "code": "72",
      "name": "Accommodation and food services",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_72_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 41529,
          "survival": 88.2,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 27547,
          "survival": 58.5,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 19587,
          "survival": 41.6,
          "line": 561
        }
      ]
    },
    {
      "code": "00",
      "name": "All private establishments",
      "sourceUrl": "https://www.bls.gov/bdm/us_age_naics_00_table7.txt",
      "rows": [
        {
          "cohort": 2015,
          "year": 2016,
          "establishments": 539701,
          "survival": 79.6,
          "line": 552
        },
        {
          "cohort": 2015,
          "year": 2017,
          "establishments": 468293,
          "survival": 69.1,
          "line": 553
        },
        {
          "cohort": 2015,
          "year": 2018,
          "establishments": 416438,
          "survival": 61.4,
          "line": 554
        },
        {
          "cohort": 2015,
          "year": 2019,
          "establishments": 375833,
          "survival": 55.4,
          "line": 555
        },
        {
          "cohort": 2015,
          "year": 2020,
          "establishments": 340281,
          "survival": 50.2,
          "line": 556
        },
        {
          "cohort": 2015,
          "year": 2021,
          "establishments": 314801,
          "survival": 46.4,
          "line": 557
        },
        {
          "cohort": 2015,
          "year": 2022,
          "establishments": 295667,
          "survival": 43.6,
          "line": 558
        },
        {
          "cohort": 2015,
          "year": 2023,
          "establishments": 273295,
          "survival": 40.3,
          "line": 559
        },
        {
          "cohort": 2015,
          "year": 2024,
          "establishments": 253300,
          "survival": 37.4,
          "line": 560
        },
        {
          "cohort": 2015,
          "year": 2025,
          "establishments": 235071,
          "survival": 34.7,
          "line": 561
        },
        {
          "cohort": 2016,
          "year": 2017,
          "establishments": 583649,
          "survival": 79.6,
          "line": 567
        },
        {
          "cohort": 2016,
          "year": 2018,
          "establishments": 504380,
          "survival": 68.8,
          "line": 568
        },
        {
          "cohort": 2016,
          "year": 2019,
          "establishments": 448758,
          "survival": 61.2,
          "line": 569
        },
        {
          "cohort": 2016,
          "year": 2020,
          "establishments": 403200,
          "survival": 55,
          "line": 570
        },
        {
          "cohort": 2016,
          "year": 2021,
          "establishments": 371334,
          "survival": 50.7,
          "line": 571
        },
        {
          "cohort": 2016,
          "year": 2022,
          "establishments": 347579,
          "survival": 47.4,
          "line": 572
        },
        {
          "cohort": 2016,
          "year": 2023,
          "establishments": 317238,
          "survival": 43.3,
          "line": 573
        },
        {
          "cohort": 2016,
          "year": 2024,
          "establishments": 292280,
          "survival": 39.9,
          "line": 574
        },
        {
          "cohort": 2016,
          "year": 2025,
          "establishments": 270207,
          "survival": 36.9,
          "line": 575
        },
        {
          "cohort": 2017,
          "year": 2018,
          "establishments": 580064,
          "survival": 79.1,
          "line": 581
        },
        {
          "cohort": 2017,
          "year": 2019,
          "establishments": 502855,
          "survival": 68.6,
          "line": 582
        },
        {
          "cohort": 2017,
          "year": 2020,
          "establishments": 445038,
          "survival": 60.7,
          "line": 583
        },
        {
          "cohort": 2017,
          "year": 2021,
          "establishments": 407322,
          "survival": 55.5,
          "line": 584
        },
        {
          "cohort": 2017,
          "year": 2022,
          "establishments": 378274,
          "survival": 51.6,
          "line": 585
        },
        {
          "cohort": 2017,
          "year": 2023,
          "establishments": 344873,
          "survival": 47,
          "line": 586
        },
        {
          "cohort": 2017,
          "year": 2024,
          "establishments": 316646,
          "survival": 43.2,
          "line": 587
        },
        {
          "cohort": 2017,
          "year": 2025,
          "establishments": 291624,
          "survival": 39.8,
          "line": 588
        },
        {
          "cohort": 2018,
          "year": 2019,
          "establishments": 582840,
          "survival": 79.4,
          "line": 593
        },
        {
          "cohort": 2018,
          "year": 2020,
          "establishments": 503729,
          "survival": 68.7,
          "line": 594
        },
        {
          "cohort": 2018,
          "year": 2021,
          "establishments": 455667,
          "survival": 62.1,
          "line": 595
        },
        {
          "cohort": 2018,
          "year": 2022,
          "establishments": 420517,
          "survival": 57.3,
          "line": 596
        },
        {
          "cohort": 2018,
          "year": 2023,
          "establishments": 380444,
          "survival": 51.9,
          "line": 597
        },
        {
          "cohort": 2018,
          "year": 2024,
          "establishments": 347801,
          "survival": 47.4,
          "line": 598
        },
        {
          "cohort": 2018,
          "year": 2025,
          "establishments": 317744,
          "survival": 43.3,
          "line": 599
        },
        {
          "cohort": 2019,
          "year": 2020,
          "establishments": 610104,
          "survival": 79.2,
          "line": 604
        },
        {
          "cohort": 2019,
          "year": 2021,
          "establishments": 540775,
          "survival": 70.2,
          "line": 605
        },
        {
          "cohort": 2019,
          "year": 2022,
          "establishments": 493448,
          "survival": 64,
          "line": 606
        },
        {
          "cohort": 2019,
          "year": 2023,
          "establishments": 436830,
          "survival": 56.7,
          "line": 607
        },
        {
          "cohort": 2019,
          "year": 2024,
          "establishments": 396937,
          "survival": 51.5,
          "line": 608
        },
        {
          "cohort": 2019,
          "year": 2025,
          "establishments": 360637,
          "survival": 46.8,
          "line": 609
        },
        {
          "cohort": 2020,
          "year": 2021,
          "establishments": 621249,
          "survival": 80.9,
          "line": 615
        },
        {
          "cohort": 2020,
          "year": 2022,
          "establishments": 554747,
          "survival": 72.3,
          "line": 616
        },
        {
          "cohort": 2020,
          "year": 2023,
          "establishments": 488169,
          "survival": 63.6,
          "line": 617
        },
        {
          "cohort": 2020,
          "year": 2024,
          "establishments": 439219,
          "survival": 57.2,
          "line": 618
        },
        {
          "cohort": 2020,
          "year": 2025,
          "establishments": 394689,
          "survival": 51.4,
          "line": 619
        },
        {
          "cohort": 2021,
          "year": 2022,
          "establishments": 663801,
          "survival": 79.1,
          "line": 625
        },
        {
          "cohort": 2021,
          "year": 2023,
          "establishments": 562531,
          "survival": 67,
          "line": 626
        },
        {
          "cohort": 2021,
          "year": 2024,
          "establishments": 495621,
          "survival": 59.1,
          "line": 627
        },
        {
          "cohort": 2021,
          "year": 2025,
          "establishments": 439753,
          "survival": 52.4,
          "line": 628
        },
        {
          "cohort": 2022,
          "year": 2023,
          "establishments": 812349,
          "survival": 76.3,
          "line": 634
        },
        {
          "cohort": 2022,
          "year": 2024,
          "establishments": 690200,
          "survival": 64.8,
          "line": 635
        },
        {
          "cohort": 2022,
          "year": 2025,
          "establishments": 599752,
          "survival": 56.3,
          "line": 636
        },
        {
          "cohort": 2023,
          "year": 2024,
          "establishments": 820039,
          "survival": 78.2,
          "line": 642
        },
        {
          "cohort": 2023,
          "year": 2025,
          "establishments": 691774,
          "survival": 65.9,
          "line": 643
        },
        {
          "cohort": 2024,
          "year": 2025,
          "establishments": 769449,
          "survival": 77.9,
          "line": 649
        }
      ]
    }
  ]
}
